import { 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updateProfile
} from 'firebase/auth';
import { auth } from './firebase';

/**
 * Realiza o login do usuário com email e senha
 * @param {string} email - Email do usuário
 * @param {string} password - Senha do usuário
 * @returns {Promise<object>} - Objeto com informações do usuário logado
 */
export const loginWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return {
      user: userCredential.user,
      success: true
    };
  } catch (error) {
    console.error('Erro ao fazer login:', error);
    return {
      error: error.message,
      success: false
    };
  }
};

/**
 * Cria um novo usuário com email e senha
 * @param {string} email - Email do usuário
 * @param {string} password - Senha do usuário
 * @returns {Promise<object>} - Objeto com informações do usuário criado
 */
export const registerWithEmail = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return {
      user: userCredential.user,
      success: true
    };
  } catch (error) {
    console.error('Erro ao registrar usuário:', error);
    return {
      error: error.message,
      success: false
    };
  }
};

/**
 * Cria um novo usuário com email e senha e atualiza o nome de exibição
 * @param {string} email - Email do usuário
 * @param {string} password - Senha do usuário
 * @param {string} displayName - Nome de exibição do usuário
 * @returns {Promise<object>} - Objeto com o usuário criado
 */
export const createUserAccount = async (email, password, displayName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    // Atualizar o nome de exibição do usuário se fornecido
    if (displayName) {
      await updateProfile(userCredential.user, {
        displayName: displayName
      });
    }
    
    return userCredential;
  } catch (error) {
    console.error('Erro ao criar conta de usuário:', error);
    throw error;
  }
};

/**
 * Realiza o logout do usuário atual
 * @returns {Promise<boolean>} - True se o logout for bem-sucedido
 */
export const logout = async () => {
  try {
    await signOut(auth);
    return true;
  } catch (error) {
    console.error('Erro ao fazer logout:', error);
    return false;
  }
};

/**
 * Envia um email de redefinição de senha
 * @param {string} email - Email do usuário
 * @returns {Promise<object>} - Resultado da operação
 */
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return {
      success: true,
      message: 'Email de redefinição enviado com sucesso'
    };
  } catch (error) {
    console.error('Erro ao enviar email de redefinição:', error);
    return {
      success: false,
      error: error.message
    };
  }
}; 